import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Junta classes do Tailwind resolvendo conflitos (a última vence). */
export function cn(...entradas: ClassValue[]) {
  return twMerge(clsx(entradas))
}

/** Primeiro nome, para as saudações da tela inicial. */
export function primeiroNome(nomeCompleto: string | null | undefined) {
  return (nomeCompleto ?? '').trim().split(/\s+/)[0] ?? ''
}

/** "Bom dia" / "Boa tarde" / "Boa noite" conforme a hora local. */
export function saudacao(agora = new Date()) {
  const hora = agora.getHours()
  if (hora < 12) return 'Bom dia'
  if (hora < 18) return 'Boa tarde'
  return 'Boa noite'
}

export function pluralizar(quantidade: number, singular: string, plural: string) {
  return quantidade === 1 ? singular : plural
}

/**
 * Extrai uma mensagem legível de qualquer coisa que um `catch` possa
 * capturar.
 *
 * `e instanceof Error ? e.message : '...'`, repetido em vários lugares
 * do app, falha exatamente no caso mais importante de diagnosticar: um
 * erro relançado através da fronteira de um Web Worker (como a
 * compressão de imagem) costuma perder o protótipo `Error` na
 * serialização, e cai sempre no texto genérico — a mensagem real do
 * problema nunca aparece nem para a participante nem para quem for
 * investigar depois.
 */
export function mensagemDeErro(e: unknown, resumo = 'Algo deu errado. Tente de novo.'): string {
  if (e instanceof Error) return e.message
  if (typeof e === 'string') return e
  if (e && typeof e === 'object' && 'message' in e && typeof e.message === 'string') {
    return e.message
  }
  return resumo
}
